import { Component, Input } from '@angular/core';
import { RouteSheetLocationDTO } from 'src/app/features/locations-map/models/RouteSheetLocationDTO';
import { RouteSheetService } from 'src/app/features/locations-map/services/RouteSheet.service';

@Component({
  selector: 'route-sheet-services-card',
  templateUrl: './services-card.component.html',
  styleUrls: ['./services-card.component.css']
})
export class RouteSheetServicesCardComponent {
  @Input() routeSheetLocation: RouteSheetLocationDTO;
  @Input() skeletonLoading: boolean = false;

  constructor(private routeSheetService: RouteSheetService) {}


}
